import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Instagram } from 'lucide-react';
import { contactInfo } from '../utils/mock';

const Footer = () => {
  return (
    <footer className="bg-slate-950 border-t border-cyan-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center group">
              <div className="relative">
                {/* Subtle glow effect for footer logo */}
                <div className="absolute inset-0 bg-cyan-400/10 rounded-lg blur-lg"></div>
                <img 
                  src="/futurebuildx-logo-original.jpeg" 
                  alt="FutureBuildX" 
                  className="relative h-14 w-auto rounded-lg transform group-hover:scale-105 transition-all duration-300 drop-shadow-md"
                />
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              Empowering students with cutting-edge technology skills in AI, Robotics, and IoT.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm">
                  Courses
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/students" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm">
                  Our Students
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm">
                  3D Products
                </Link>
              </li>
              <li>
                <Link to="/partnerships" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm">
                  Partnerships & Achievements
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>AI & Robotics Workshops</li>
              <li>IoT Training</li>
              <li>3D Printing Services</li>
              <li>PCB Designing</li>
              <li>Project Guidance</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-gray-400 text-sm">
                <Mail size={18} className="text-cyan-400 mt-0.5 flex-shrink-0" />
                <span>{contactInfo.email}</span>
              </li>
              <li className="flex items-start space-x-3 text-gray-400 text-sm">
                <Phone size={18} className="text-cyan-400 mt-0.5 flex-shrink-0" />
                <div className="flex flex-col space-y-1">
                  <span>{contactInfo.phone}</span>
                  <span>{contactInfo.phone2}</span>
                </div>
              </li>
              <li className="flex items-start space-x-3 text-gray-400 text-sm">
                <MapPin size={18} className="text-cyan-400 mt-0.5 flex-shrink-0" />
                <span>{contactInfo.address}</span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex items-center space-x-4 mt-6">
              <a
                href={contactInfo.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-cyan-400 transition-colors duration-300"
              >
                <Linkedin size={20} />
              </a>
              <a
                href={contactInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-cyan-400 transition-colors duration-300"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-cyan-500/20 mt-12 pt-8 text-center text-gray-400 text-sm">
          <p>© {new Date().getFullYear()} FutureBuildX. All rights reserved. Built with passion for innovation.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
